import { ISafetyCaseActionValues, ISafetyCaseActionUpsertValues } from './safety-case-action-form-types'
import { ISafetyCaseAction, ISafetyCaseActionUpsert, IDocument } from '../../../../interfaces'

export const safetyCaseActionToSafetyCaseActionValues = (
  safetyCaseAction: ISafetyCaseAction,
): ISafetyCaseActionUpsertValues | undefined => {
  if (!safetyCaseAction) {
    return undefined
  }

  return {
    actionTypeId: safetyCaseAction?.actionTypeId,
    actionTypeText: safetyCaseAction?.actionTypeText,
    occurrenceDate: safetyCaseAction?.occurrenceDate,
    notes: safetyCaseAction?.notes,
    documents: safetyCaseAction?.documents,
  }
}

export const safetyCaseActionValuesToSafetyCaseActionAddUpsert = (
  safetyCaseActionValues: ISafetyCaseActionValues,
  payload: { safetyCaseId?: number; airportId: number },
): ISafetyCaseActionUpsert | undefined => {
  if (!safetyCaseActionValues || !payload?.safetyCaseId) {
    return undefined
  }

  return {
    id: 0,
    airportId: payload?.airportId,
    safetyCaseId: payload?.safetyCaseId,
    actionTypeId:
      typeof safetyCaseActionValues?.actionTypeId === 'string' ? undefined : safetyCaseActionValues?.actionTypeId,
    actionTypeText:
      typeof safetyCaseActionValues?.actionTypeId === 'string' ? safetyCaseActionValues?.actionTypeId : undefined,
    occurrenceDate: safetyCaseActionValues?.occurrenceDate,
    notes: safetyCaseActionValues?.notes,
    documentIds: (safetyCaseActionValues?.documents || [])?.map((document: IDocument) => document.id),
  }
}

export const safetyCaseActionValuesToSafetyCaseActionUpdateUpsert = (
  safetyCaseActionValues: ISafetyCaseActionValues,
  safetyCaseAction?: ISafetyCaseAction,
): ISafetyCaseActionUpsert | undefined => {
  if (!safetyCaseActionValues || !safetyCaseAction) {
    return undefined
  }

  return {
    ...safetyCaseAction,
    occurrenceDate: safetyCaseAction?.occurrenceDate,
    lastUpdatedAt: safetyCaseAction?.lastUpdatedAt,
    actionTypeId:
      typeof safetyCaseActionValues?.actionTypeId === 'string' ? undefined : safetyCaseActionValues?.actionTypeId,
    actionTypeText:
      typeof safetyCaseActionValues?.actionTypeId === 'string' ? safetyCaseActionValues?.actionTypeId : undefined,
    notes: safetyCaseActionValues?.notes,
    documentIds: (safetyCaseActionValues?.documents || [])?.map((document: IDocument) => document.id),
  }
}
